"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Scheduling = /*#__PURE__*/function () {
  function Scheduling(client) {
    (0, _classCallCheck2["default"])(this, Scheduling);
    this.client = client;
    this.resourceUrl = '/calendar';
  }

  (0, _createClass2["default"])(Scheduling, [{
    key: "connectCalendar",
    value: function connectCalendar(calendarType, data) {
      return this.client.get("".concat(this.resourceUrl, "/authenticate/").concat(calendarType), data);
    }
  }, {
    key: "connectAppleCalendar",
    value: function connectAppleCalendar(data) {
      return this.client.post("".concat(this.resourceUrl, "/authenticate/connect-apple-calendar"), data);
    }
  }, {
    key: "getAllConnectedCalendars",
    value: function getAllConnectedCalendars(coachId) {
      return this.client.get("".concat(this.resourceUrl, "/coach/").concat(coachId, "/connected-calendars"));
    } // Read-only admin preview: open slots a client would see for the coach.
    // timezone is optional; leave it out so the backend uses the coach's timezone.

  }, {
    key: "getCoachAvailableSlotsPreview",
    value: function getCoachAvailableSlotsPreview(coachId) {
      var _this$client;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          year = _ref.year,
          month = _ref.month,
          duration = _ref.duration,
          timezone = _ref.timezone;

      var params = ["year=".concat(year), "month=".concat(month)];
      if (duration) params.push("duration=".concat(duration));
      if (timezone) params.push("timezone=".concat(encodeURIComponent(timezone)));

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return (_this$client = this.client).get.apply(_this$client, ["/coach/".concat(coachId, "/available-slots-preview?").concat(params.join('&'))].concat(args));
    } // Read-only admin preview: the coach's live calendar events for a month, with why each one does or doesn't block booking.

  }, {
    key: "getCoachCalendarPreview",
    value: function getCoachCalendarPreview(coachId) {
      var _this$client2;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          year = _ref2.year,
          month = _ref2.month;

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["".concat(this.resourceUrl, "/coach/").concat(coachId, "/calendar-preview?year=").concat(year, "&month=").concat(month)].concat(args));
    }
  }, {
    key: "getCoachScheduledList",
    value: function getCoachScheduledList() {
      var _this$client3;

      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var limit = queryParams.limit,
          page = queryParams.page,
          clientId = queryParams.clientId,
          status = queryParams.status,
          sortBy = queryParams.sortBy,
          sortOrder = queryParams.sortOrder,
          allCoaches = queryParams.allCoaches;
      var url = '/coach/scheduled-events';
      var params = [];

      if (limit) {
        params.push("limit=".concat(limit));
      }

      if (page) {
        params.push("page=".concat(page));
      }

      if (clientId) {
        params.push("clientId=".concat(clientId));
      }

      if (status) {
        params.push("status=".concat(status));
      }

      if (sortBy) {
        params.push("sortBy=".concat(sortBy));
      }

      if (sortOrder) {
        params.push("sortOrder=".concat(sortOrder));
      }

      if (allCoaches) {
        params.push('allCoaches=true');
      }

      if (params.length > 0) {
        url += "?".concat(params.join('&'));
      }

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, [url].concat(args));
    }
  }, {
    key: "getCoachToBeSchedulingList",
    value: function getCoachToBeSchedulingList() {
      var _this$client4;

      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var page = queryParams.page,
          limit = queryParams.limit,
          clientId = queryParams.clientId;
      var url = '/coach/pending-scheduling';
      var params = [];

      if (limit) {
        params.push("limit=".concat(limit));
      }

      if (page) {
        params.push("page=".concat(page));
      }

      if (clientId) {
        params.push("clientId=".concat(clientId));
      }

      if (params.length > 0) {
        url += "?".concat(params.join('&'));
      }

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return (_this$client4 = this.client).get.apply(_this$client4, [url].concat(args));
    }
  }, {
    key: "getCoachClients",
    value: function getCoachClients(coachId) {
      var _this$client5;

      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var hasSow = queryParams.hasSow;
      var url = "/coach/".concat(coachId, "/clients");
      var params = [];

      if (hasSow !== undefined) {
        params.push("hasSow=".concat(hasSow));
      }

      if (params.length > 0) {
        url += "?".concat(params.join('&'));
      }

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return (_this$client5 = this.client).get.apply(_this$client5, [url].concat(args));
    }
  }, {
    key: "getCalendarLimit",
    value: function getCalendarLimit() {
      return this.client.get('/coach/calendar-availability');
    }
  }, {
    key: "getCoachCalendarLimits",
    value: function getCoachCalendarLimits() {
      return this.client.get('/coach/calendar-limits');
    }
  }, {
    key: "updateCalendarAvailability",
    value: function updateCalendarAvailability(payload) {
      return this.client.put('/coach/calendar-availability', payload);
    }
  }, {
    key: "updateCoachCalendarLimits",
    value: function updateCoachCalendarLimits(payload) {
      return this.client.put('/coach/calendar-limits', payload);
    }
  }, {
    key: "cancelBooking",
    value: function cancelBooking(coachId, eventId) {
      var _this$client6;

      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return (_this$client6 = this.client)["delete"].apply(_this$client6, ["".concat(this.resourceUrl, "/coach/").concat(coachId, "/events/").concat(eventId)].concat(args));
    }
  }, {
    key: "removeDateOverride",
    value: function removeDateOverride(overrideId) {
      var _this$client7;

      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return (_this$client7 = this.client)["delete"].apply(_this$client7, ["/coach/calendar-availability/override/".concat(overrideId)].concat(args));
    }
  }, {
    key: "deleteCalendarCredential",
    value: function deleteCalendarCredential(coachId, credentialId) {
      var _this$client8;

      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return (_this$client8 = this.client)["delete"].apply(_this$client8, ["".concat(this.resourceUrl, "/coach/").concat(coachId, "/credentials/").concat(credentialId)].concat(args));
    }
  }, {
    key: "checkOverrideConflicts",
    value: function checkOverrideConflicts(payload) {
      var _this$client9;

      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return (_this$client9 = this.client).post.apply(_this$client9, ['/coach/overrides/conflicts', payload].concat(args));
    }
  }]);
  return Scheduling;
}();

exports["default"] = Scheduling;